import { styled } from 'styled-components'
import { Block } from 'suomifi-ui-components'

export const LastNameInfoBlock = styled(Block)`
  margin: ${({ theme }) => theme.spacing.xl} 0;

  p + div,
  div + p {
    margin-top: ${({ theme }) => theme.spacing.s};
  }
`
